export function mixin(Hop) {
    // See http://stackoverflow.com/a/28002292
    Hop.getScript = (source, callback) => {
        let script = document.createElement('script');
        const prior = document.getElementsByTagName('script')[0];
        // script.async = 1; We don't want async as critical must be usable immediately after loaded
        prior.parentNode.insertBefore(script, prior);

        script.onload = script.onreadystatechange = function (unused, isAbort) {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                script.onload = script.onreadystatechange = null;
                script = undefined;
                !isAbort && callback && callback();
            } else {
                Hop.logError('Could not load script "' + source + '" (see error detail in next log)');
                Hop.logError({isAbort, readyState: script.readyState && /loaded|complete/.test(script.readyState)});
            }
        };

        script.src = source;
    };
}
